export const ReceiveMessage = {
    UpdateJob: 'UpdateJob',
    UpdateBatchJob: 'UpdateBatchJob',
    UpdateMessage: 'UpdateMessage',
    CreateJob: 'CreateJob',
    Progress: 'Progress',
}